//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Wrapper from "../Layout/Wrapper";
import Parallax from "../Layout/Parallax";
import Container from "../Layout/Container";
import CdnImage from "../Image/CdnImage";
const Badge = () => import("../Badge/Badge");

export default {
    name: "FeatureScreen",

    components: {CdnImage, Container, Wrapper, Parallax, Badge},

    props: {

        // The title to show
        title: {
            type: String,
            default: null
        },

        // The description to show
        description: {
            type: String,
            default: null
        },

        // The lang key prefix for the text to show
        langPrefix: {
            type: String,
            default: null
        },

        // The image to sho on the screen
        image: {
            type: String,
            required: true
        },

        // The feature text alignment
        align: {
            type: String,
            default: 'right'
        },

        // Whether to vertically align the content on the top
        top: {
            type: Boolean,
            default: false
        },

        hideTitleOnMobile: {
            type: Boolean,
            default: false
        },

        // Whether to show a description
        showDescription: {
            type: Boolean,
            default: true
        },

        // Whether a new badge shall be placed next to the title
        newBadge: {
            type: Boolean,
            default: false
        },

        // Whether a beta badge shall be placed next to the title
        betaBadge: {
            type: Boolean,
            default: false
        }
    }
}
